<template>
  <b-card
    :id="indicator.id"
    class="info"
    :class="compact ? 'compact' : ''"
    :style="{ minHeight: height }"
  >
    <h4 v-if="showTitle" class="card-title">
      {{ $t("label_reports_genderGap_indicatorInformation_title") }}
    </h4>
    <h5 style="font-size:1.125rem" class="card-subtitle">
      {{ $t(indicator.acronym) }} - {{ $t(indicator.name) }}
    </h5>
    <p class="card-text">
      <span>{{ $t("label_reports_genderGap_objective_title") }}</span>
      {{ $t(indicator.objective) }}
    </p>
    <div class="indexs">
      <div class="convention">
        <p>
          {{ $t("label_reports_genderGap_pillarIndicator_lettlerhead_title") }}
        </p>
        <div class="index dark">
          {{ $t("label_indicator_" + indicatorId + "_acronym") }}
        </div>
      </div>
      <div class="convention">
        <p>{{ $t("label_reports_genderGap_indicatorValue_caption") }}</p>
        <div
          v-if="indicator.ranges"
          class="index"
          :class="
            getColorStateValue(
              indicator.value,
              indicator.ranges,
              indicator.errorOnValueFormula
            )
          "
        >
          {{ indicator.value | currency("", 2, { thousandsSeparator: "" })
          }}<span v-if="indicator.indicator_value_scale === 'percentage'"
            >%</span
          >
        </div>
      </div>
      <!--      <div class="convention">
        <p>{{ $t('label_reports_genderGap_indexValue_caption')}}</p>
        <div class="index" v-if="indicator.ranges" :class="getColorStateIndex(indicator.index, indicator.errorOnIndexFormula)"> {{ indicator.index | currency('', 0, { thousandsSeparator: '' }) }}%</div>
      </div>-->
    </div>
    <div
      v-if="indicator.errorOnIndexFormula == 'true'"
      class="mt-3"
      align="center"
    >
      <p class="card-text">
        {{ $t("label_reports_notEnoughDataIndicator") }}
      </p>
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
import { axiosCall } from "@/utils/axiosCall";
export default {
  name: "CardIndicatorInfo",
  props: {
    pillarId: {
      type: String,
      default: "PP",
    },
    indicatorId: {
      type: String,
      default: "PP1",
    },
    height: {
      type: String,
      default: "auto",
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      indicator: {},
      showTitle: true,
      showModal: false,
      color: "positive",
      comment: "",
    };
  },
  methods: {
    saveComment: async function () {
      const data = {
        comment: this.comment,
        snapshotId: this.getCurrentSnapshot.snapshotId,
        // eslint-disable-next-line camelcase
        indicator_acronym: this.indicator.id,
      };
      await axiosCall({ url: "IndicatorComments", method: "POST", data }).then(
        () => {
          this.$emit("commentCreated");
          this.showModal = false;
        }
      );
    },
  },
  computed: mapGetters([
    "getIndicatorData",
    "getColorStateValue",
    "getColorStateIndex",
    "getCurrentSnapshot",
  ]),
  watch: {
    indicatorId: function () {
      this.indicator = this.getIndicatorData(this.pillarId, this.indicatorId);
    },
  },
  mounted() {
    this.indicator = this.getIndicatorData(this.pillarId, this.indicatorId);
  },
  updated() {
    var offsetHeight = document.getElementById(this.indicator.id).offsetHeight;
    if (offsetHeight > parseInt(this.height.split("px")[0]) + 37) {
      this.showTitle = false;
    }
  },
};
</script>

<style lang="scss" scoped>

/* components/cards/CardIndicatorInfo*/

@import "../../assets/css/variables.scss";
.indexs {
  display: flex;
  justify-content: center;
  .convention {
    font-size: 1rem;
    text-align: center;
    margin: 0 10px;
    font-weight: bold;
    font-family: $font-subtitle;
    width: 175px;
    p {
      margin-bottom: 0;
      height: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .index {
      top: 0px;
      padding: 5 10px;
      font-size: 2rem;

      border-radius: 5px;
      color: #ffffff;
      text-align: center;
    }
  }
}
.dark {
  background-color: #000;
}
.compact {
  .card-subtitle {
    font-size: 1rem;
    margin: 0;
  }
  .card-text {
    font-size: 0.8rem;
    margin: 0px;
  }
  .convention {
    font-size: 0.8rem;
    .index {
      font-size: 1.6rem;
    }
  }
}
.IndicatorAddComment {
  color: #949293;
  position: absolute;
  bottom: 15px;
  right: 15px;
  font-weight: bold;
  cursor: pointer;
  .IndicatorAddCommentPlus {
    font-size: 38px;
    font-weight: 100;
    background-color: #949293;
    color: #FFFFFF;
    padding: 0px 5px;
    line-height: 32px;
    display: inline-block;
    margin-left: 10px;
  }
}
</style>
